import { Pipe, PipeTransform } from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';
@Pipe({
    name: 'stbyDateFormat',
})
export class DateFormatPipe implements PipeTransform {
    transform(value: string | number | Dayjs | Date, format: string): string {
        return value ? dayjs(value).format(format) : '';
    }
}
